import { useDocumentEventListener } from "./useDocumentEventListener";

/**
 * Calls handler with the new visibility state whenever the browser tab visibility changes.
 * Handler is stored in a ref — callers do not need to memoize it.
 */
export function useVisibilityChange(handler: (state: DocumentVisibilityState) => void): void {
  useDocumentEventListener("visibilitychange", () => handler(document.visibilityState));
}
